import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';

@Component({
    selector: 'c-collapse',
    templateUrl: './collapse.component.html',
    styleUrl: './collapse.component.css',
    standalone: false
})
export class CollapseComponent {
  @Input() idCollapse = '';
  @ContentChild('contenidoHtml') contenidoHtml!: TemplateRef<any>;
  @Input() titulo!: string;
  @Input() show = true;
  @Input() small = false;
  @Input() fx!: Function | undefined;
  @Input() ayuda: boolean = false;
  @Input() ayudaText: string = 'Ayuda';
  @Input() cerrar: boolean = false;
  @Input() error: boolean = false;
  @Output() cerrarBtn = new EventEmitter<boolean>();
  cerrarClick() {
    this.cerrarBtn.emit(true);
  }

  hide() {
    if (!this.otherAction) this.show = !this.show;
    this.otherAction = false;
  }

  otherAction = false;

  @Output() onAyudaClick = new EventEmitter<boolean>();
  ayudaClick() {
    this.onAyudaClick.emit(true);
  }

  @Output() viewportVisible = new EventEmitter<boolean>();
  onVisibilityChange(isVisible: boolean) {
    if (isVisible) {
      this.viewportVisible.emit(true);
    } else {
      this.viewportVisible.emit(false);
    }
  }
}
